import { Card, CardContent, Typography } from '@mui/material'
import React from 'react'
import { getIdentityName } from '../../utils/identity'

const SummaryCard = ({ customerQuery, customerContactsQuery, dropdowns }) => {
  const isLoading = customerContactsQuery.isLoading || customerQuery.isLoading
  const hasLoadError =
    customerContactsQuery.hasLoadError || customerQuery.hasLoadError

  if (isLoading || hasLoadError) return null

  const { primaryContact } = customerContactsQuery

  const { customer } = customerQuery

  const nextStepDropdown = dropdowns?.find((dd) => dd.key === 'nextStep')

  const nextStep = nextStepDropdown?.options?.find(
    (o) => o.id === customer?.dropdowns?.nextStepTypeId
  )

  return (
    <Card>
      <CardContent>
        <Typography>
          <b>Primary Contact:</b>
        </Typography>
        <Typography sx={{ ml: 2 }}>
          {primaryContact ? getIdentityName(primaryContact) : <i>(none)</i>}
          <br></br>
          {primaryContact?.type}
        </Typography>
        <Typography sx={{ maxWidth: '300px', textWrap: 'wrap' }}>
          <b>Product of Interest:</b> {customer?.productOfInterest}
        </Typography>
        <Typography>
          <b>Next Step:</b> {nextStep?.name}
        </Typography>
      </CardContent>
    </Card>
  )
}

export default SummaryCard
